// Work around for better UX -> https://github.com/vercel/swr/issues/192

import { useRef } from 'react';

import useSWR from 'swr';

const useStickySWR = (...args) => {
  const dataRef = useRef();

  const { data, ...rest } = useSWR(...args);

  if (data !== undefined) {
    dataRef.current = data;
  }

  return {
    ...rest,
    data: dataRef.current,
  };
};

export default useStickySWR;
